import { PaymentModuleId } from '@foundation/apis/payments';
// eslint-disable-next-line import-x/default -- bowser only has a default export; getParser is a method on it
import Bowser from 'bowser';

export function excludeBraintreeSepaForSafari(methods: PaymentModuleId[]) {
  /*
  TODO: This is a temp funtion to exclude Braintree SEPA from the list of avilable payment methods for working in Safari browser.
        Once Braintree will fix issue with Safari on their side this code shouls be removed and no exclusion should be made.
  */
  const browser = Bowser.getParser(window.navigator.userAgent);

  return methods.filter(function (item) {
    const isSafari = browser.getBrowser().name === 'Safari';
    const isBraintreeSepa = item === PaymentModuleId.BraintreeSepa;
    return !(isBraintreeSepa && isSafari);
  });
}
